var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccuracy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.83 8.64L19.12 7.94L15.5 11.64L13.85 10L13.15 10.7L15.5 13.06L19.83 8.64ZM4 19H28V2H4V19ZM5 3H27V18H5V3ZM30 20V0H2V20H0V25H32V20H30ZM3 1H29V20H3V1ZM17.69 21L17.19 22H14.81L14.31 21H17.69ZM31 24H1V21H13.19L14.19 23H17.81L18.81 21H31V24ZM8 10H8.5C8.63261 10 8.75979 10.0527 8.85355 10.1464C8.94732 10.2402 9 10.3674 9 10.5C9 10.6326 8.94732 10.7598 8.85355 10.8536C8.75979 10.9473 8.63261 11 8.5 11H8V15H24V11H23.5C23.3674 11 23.2402 10.9473 23.1464 10.8536C23.0527 10.7598 23 10.6326 23 10.5C23 10.3674 23.0527 10.2402 23.1464 10.1464C23.2402 10.0527 23.3674 10 23.5 10H24V6H8V10ZM9 7H23V9.09C22.7059 9.19048 22.4505 9.38044 22.2697 9.63328C22.0889 9.88611 21.9917 10.1892 21.9917 10.5C21.9917 10.8108 22.0889 11.1139 22.2697 11.3667C22.4505 11.6196 22.7059 11.8095 23 11.91V14H9V11.91C9.29415 11.8095 9.5495 11.6196 9.73031 11.3667C9.91112 11.1139 10.0083 10.8108 10.0083 10.5C10.0083 10.1892 9.91112 9.88611 9.73031 9.63328C9.5495 9.38044 9.29415 9.19048 9 9.09V7Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccuracy);
export default __webpack_public_path__ + "static/media/Accuracy.c219f1a403c53637864299294847ce7d.svg";
export { ForwardRef as ReactComponent };